export type OptionGroup = {
  label: string;
  options: {
    value: string;
    label: string;
  }[];
}[];

export const autocompleteOptions: OptionGroup = [
  {
    label: "Personal Information",
    options: [
      { value: "name", label: "Name" },
      { value: "honorific-prefix", label: "Honorific Prefix" },
      { value: "given-name", label: "Given Name" },
      { value: "additional-name", label: "Additional Name" },
      { value: "family-name", label: "Family Name" },
      { value: "honorific-suffix", label: "Honorific Suffix" },
      { value: "nickname", label: "Nickname" },
    ],
  },
  {
    label: "Address",
    options: [
      { value: "organization-title", label: "Organization Title" },
      { value: "username", label: "Username" },
      { value: "new-password", label: "New Password" },
      { value: "current-password", label: "Current Password" },
      { value: "organization", label: "Organization" },
      { value: "street-address", label: "Street Address" },
      { value: "address-line1", label: "Address Line 1" },
      { value: "address-line2", label: "Address Line 2" },
      { value: "address-line3", label: "Address Line 3" },
      { value: "address-level4", label: "Address Level 4" },
      { value: "address-level3", label: "Address Level 3" },
      { value: "address-level2", label: "Address Level 2" },
      { value: "address-level1", label: "Address Level 1" },
      { value: "country", label: "Country" },
      { value: "country-name", label: "Country Name" },
      { value: "postal-code", label: "Postal Code" },
    ],
  },
  {
    label: "Contact Information",
    options: [
      { value: "email", label: "Email" },
      { value: "tel", label: "Telephone" },
      { value: "tel-country-code", label: "Telephone Country Code" },
      { value: "tel-national", label: "Telephone National" },
      { value: "tel-area-code", label: "Telephone Area Code" },
      { value: "tel-local", label: "Telephone Local" },
      { value: "tel-local-prefix", label: "Telephone Local Prefix" },
      { value: "tel-local-suffix", label: "Telephone Local Suffix" },
      { value: "tel-extension", label: "Telephone Extension" },
    ],
  },
  {
    label: "Financial Information",
    options: [
      { value: "cc-name", label: "Credit Card Name" },
      { value: "cc-given-name", label: "Credit Card Given Name" },
      { value: "cc-additional-name", label: "Credit Card Additional Name" },
      { value: "cc-family-name", label: "Credit Card Family Name" },
      { value: "cc-number", label: "Credit Card Number" },
      { value: "cc-exp", label: "Credit Card Expiry" },
      { value: "cc-exp-month", label: "Credit Card Expiry Month" },
      { value: "cc-exp-year", label: "Credit Card Expiry Year" },
      { value: "cc-csc", label: "Credit Card CSC" },
      { value: "cc-type", label: "Credit Card Type" },
    ],
  },
  {
    label: "Miscellaneous",
    options: [
      { value: "transaction-currency", label: "Transaction Currency" },
      { value: "transaction-amount", label: "Transaction Amount" },
      { value: "language", label: "Language" },
      { value: "bday", label: "Birthday" },
      { value: "bday-day", label: "Birthday Day" },
      { value: "bday-month", label: "Birthday Month" },
      { value: "bday-year", label: "Birthday Year" },
      { value: "sex", label: "Gender" },
      { value: "url", label: "Website URL" },
      { value: "photo", label: "Photo URL" },
      { value: "off", label: "No Autocomplete" },
    ],
  },
];
